export const JURISDICTION_MAPPINGS = {
    1: 'Auckland System Management (ASM)',
    2: 'Auckland Transport (AT)',
    12: 'Ara Tūhono / Puhoi to Warkworth (P2W)',
};

export const CARS_ACTIVATION_STATUS = {
    ACTIVATED: 'Activated',
    DEACTIVATED: 'Deactivated',
};
